  import * as React from "react";
  import { emphasize, styled } from "@mui/material/styles";
  import Breadcrumbs from "@mui/material/Breadcrumbs";
  import Chip from "@mui/material/Chip";
  import HomeIcon from "@mui/icons-material/Home";
  import Box from "@mui/material/Box";
  import MeetTable from "./MeetTable";
  
  const StyledBreadcrumb = styled(Chip)(({ theme }) => ({
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    color: (theme.vars || theme).palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(theme.palette.grey[100], 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[100], 0.12),
    },
  }));
  
  const MeetOverview = () => {
    const handleClick = (event) => {
      event.preventDefault();
    };
  
    return (
      <Box role="presentation" onClick={handleClick} sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ padding: "20px", paddingLeft: "15px" }}>
          <StyledBreadcrumb
            component="a"
            href="#"
            label={<span style={{ fontWeight: 700 }}>Home</span>}
            icon={<HomeIcon fontSize="small" />}
          />
        </Breadcrumbs>
        <Box sx={{ flexGrow: 1, minHeight: 0}}>
          <MeetTable />
        </Box>
      </Box>
    );
  };
  
  export default MeetOverview;
  